module.exports = __webpack_public_path__ + "img/whgc.70a6a75a.png";